import axios from 'axios';

// Determine API base URL
const getApiBaseURL = () => {
  // If environment variable is set, use it (takes priority)
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  // Auto-detect: use relative URL on production domain, absolute URL for localhost
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return 'http://localhost:5000/api';
    }
    // For production (phonestream.online), use relative URL
    return '/api';
  }
  
  // Fallback for SSR or edge cases
  return '/api';
};

const api = axios.create({
  baseURL: getApiBaseURL(),
  headers: {
    'Content-Type': 'application/json'
  }
});

// Get wallet address from Web3 context (stored in localStorage or available globally)
const getWalletAddress = () => {
  // Try to get from window.ethereum first (most reliable)
  if (window.ethereum && window.ethereum.selectedAddress) {
    localStorage.setItem('walletAddress', window.ethereum.selectedAddress);
    return window.ethereum.selectedAddress;
  }
  
  // Try to get from localStorage
  const stored = localStorage.getItem('walletAddress');
  if (stored) return stored;
  
  return null;
};

// Add token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // Always include wallet address — authenticateOrWallet uses it as fallback
    // if the JWT is missing or expired, preventing silent 401 failures
    const walletAddress = getWalletAddress();
    if (walletAddress) {
      config.headers['x-wallet-address'] = walletAddress;
    }
    // Don't set Content-Type for FormData - let browser set it with boundary
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Don't redirect immediately - allow components to handle the error
      // This enables test mode where users can view dashboard without full auth
      const token = localStorage.getItem('token');
      if (token) {
        // Only clear token if we had one (user was logged in before)
        // Don't redirect - let components handle it
        console.warn('Authentication required. Some features may be limited.');
      }
    }
    return Promise.reject(error);
  }
);

export default api;
